import * as React from "react";

function SvgGrupo560(props) {
  return (
    <svg width={62} height={62} {...props}>
      <defs>
        <linearGradient
          id="Grupo-560_svg__prefix__linear-gradient"
          x1={1}
          x2={0}
          y2={1}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fff3f6" />
          <stop offset={1} stopColor="#ffced8" />
        </linearGradient>
        <clipPath id="Grupo-560_svg__prefix__clip-path">
          <path
            id="Grupo-560_svg__prefix__Caminho_155"
            d="M30.661 41.15H8.289a2.785 2.785 0 01-2.814-2.756V11.906A2.785 2.785 0 018.289 9.15h22.372a2.785 2.785 0 012.814 2.756v26.488a2.786 2.786 0 01-2.814 2.756z"
            className="Grupo-560_svg__prefix__cls-1"
            data-name="Caminho 155"
            transform="translate(-5.475 -9.15)"
          />
        </clipPath>
        <style>
          {
            ".Grupo-560_svg__prefix__cls-1{fill:url(#Grupo-560_svg__prefix__linear-gradient)}"
          }
        </style>
      </defs>
      <g
        id="Grupo-560_svg__prefix__Grupo_560"
        data-name="Grupo 560"
        transform="translate(-579 -232)"
      >
        <g
          id="Grupo-560_svg__prefix__Grupo_532"
          data-name="Grupo 532"
          transform="translate(-73 94)"
        >
          <path
            id="Grupo-560_svg__prefix__Caminho_248"
            d="M16 0h30a16 16 0 0116 16v30a16 16 0 01-16 16H16A16 16 0 010 46V16A16 16 0 0116 0z"
            className="Grupo-560_svg__prefix__cls-1"
            data-name="Caminho 248"
            transform="translate(652 138)"
          />
          <rect
            id="Grupo-560_svg__prefix__Ret\xE2ngulo_376"
            width={56}
            height={56}
            fill="#fffafb"
            data-name="Ret\xE2ngulo 376"
            rx={13}
            transform="translate(655 141)"
          />
        </g>
        <g
          id="Grupo-560_svg__prefix__Grupo_531"
          data-name="Grupo 531"
          transform="translate(596 247)"
        >
          <g
            id="Grupo-560_svg__prefix__Grupo_de_m\xE1scara_61"
            clipPath="url(#Grupo-560_svg__prefix__clip-path)"
            data-name="Grupo de m\xE1scara 61"
          >
            <g
              id="Grupo-560_svg__prefix__black-male-user-symbol"
              transform="translate(.296)"
            >
              <path
                id="Grupo-560_svg__prefix__Caminho_154"
                d="M28.419 25.264l-.11.129A17.779 17.779 0 0114.716 32a17.778 17.778 0 01-13.595-6.607l-.109-.129.026-.166a13.708 13.708 0 016.717-10.119l.258-.146.206.211a9.087 9.087 0 0012.991 0l.206-.211.258.146A13.711 13.711 0 0128.393 25.1zm-13.7-9.283a8.085 8.085 0 008.158-7.99 8.16 8.16 0 00-16.317 0 8.086 8.086 0 008.156 7.99z"
                className="Grupo-560_svg__prefix__cls-1"
                data-name="Caminho 154"
                transform="translate(-1.012)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgGrupo560;

